import useGetProductInitialValues from './useGetProductInitialValues'

export default useGetProductInitialValues
